import React from 'react';
import warningIcon from 'assets/images/warning.png';
import { useTranslation } from 'react-i18next';

import './styles.css';

const ErrorPopUp = (props) => {
  const { t } = useTranslation();

  const getTitle = () => {
    if (props.title) {
      return props.title;
    }

    return t('ohno_title');
  };

  const getDescription = () => {
    if (props.description) {
      return props.description;
    }
    
    return t('error_description');
  };

  return (
    <>
      <div className={`alert-popup-overlay ${(props.show ? 'popUp-fade-in' : '')}`}>
        <div className="error-alert-popup popup-details">
          <div className="heading-icon">
            <img src={warningIcon} alt="Warning Icon" />
          </div>
          <div className="popup-content">
            <h3 className="popup-title">{getTitle()}</h3>
            <p className="popup-description">
              {' '}
              {getDescription()}
              {' '}
            </p>
          </div>
          <div className="popup-footer">
            {
            props.onBack && (
              <button className="goback-link" onClick={props.onBack}>
                {' '}
                {(props.btnBackText || t('go_back_title'))}
                {' '}
              </button>
            )
          }
          </div>
        </div>
      </div>
    </>
  );
};

export default ErrorPopUp;
